export default [
    {
        id: 1,
        label: '建议'
    },
    {
        id: 2,
        label: '提问'
    },
    {
        id: 3,
        label: '投诉'
    }
]
